export const SET_ROLE = 'SetRole';
export const DELETE_ROLE = 'DeleteRole';
export const SET_ROLES = 'SetRoles';
export const SET_RELOAD_ROLES = 'SetReloadRoles';

export const SET_PERMISSIONS = 'SetPermissions';
export const SET_RELOAD_PERMISSIONS = 'SetReloadPermissions';

export const ROLE_HISTORY_LOGS = 'RoleHistoryLogs';
export const SET_ROLE_HISTORY_LOGS = 'SetRoleHistoryLogs';
export const INTERNAL_ROLES = 'InternalRoles';
export const SET_INTERNAL_ROLES = 'SetInternalRoles';
export const CONSULTANT_ROLES = 'ConsultantRoles';
export const SET_CONSULTANT_ROLES = 'SetConsultantRoles';
export const LOAD_ROLES_WITH_PERMISSIONS = 'LoadRolesWithPermissions';

import { TOAST_MESSAGES_PUSH as toastMessagesPush } from '@/sections/toast-mutation-types';
export const TOAST_MESSAGES_PUSH = toastMessagesPush;
